import React, {useState, useEffect, useContext, useRef} from "react";
import ListItem, {ICON_TYPES} from "@common/ListItem";
import ListGroup from "@common/ListGroup";
import {TemplateContext} from "@common/context/TemplateContext";
import {ContentContext} from "@context/ContentContext";
import {AudioIcon, DownloadFileIcon, ExampleIcon, TextbookIcon, ReviewIcon, TryItIcon, VideoIcon, WidgetIcon, WorksheetIcon, WorksheetSolutionIcon} from "@common/icons";
import {NavigationContext} from "@common/context/NavigationContext";

const ResourceNavigation = props => {
    const {shortcutLocation} = useContext(TemplateContext);
    const {content, setDialogMediaObject} = useContext(ContentContext);
    const [resourceGroups, setResourceGroups] = useState(props.resourceGroups);
    const { setNavVisible } = useContext(NavigationContext);

    let otherListGroupOptions  = {}
    if (props.indicatorPlacement) otherListGroupOptions.indicatorPlacement = props.indicatorPlacement;

    const audioRef = useRef(new Audio());

    useEffect(() => {
        if(content.currentConcept !== undefined) {
            loadResources(content.currentConcept.conceptId);
        }
    }, [content, shortcutLocation]);

    if(resourceGroups === undefined || resourceGroups.length == 0) {
        return null;
    }

    const handleScrollToExample = (exampleNum) => {
        closeDialogs();
        var $exampleBox = $(".box-example[value='" + exampleNum + "']");
        if($exampleBox.size() == 0) {
            $exampleBox = $(".example[value='" + exampleNum + "']");
        }
        if($exampleBox.size() == 0) {
            $exampleBox = $(".cont-example-anchor[data-example-num='" + exampleNum + "']");
        }

        if($exampleBox.size() > 0) {
            if($exampleBox.hasClass('close')) {
                $('.examp-head, .exampleHead, .box-heading', $exampleBox).trigger('click');
            }
            $('.cont-block-accordion', $exampleBox).addClass('cont-block-accordion-show');

            var scrollPos = $exampleBox.offset().top - 50;
            var $content = $('#contentPanel');

            $content.scrollTop($content.scrollTop() - $content.offset().top + scrollPos);

            return true
        }

        return false;
    }

    return (
        <ul className={'ch-list ch-nav-divided'}>
            {
                resourceGroups.map((resourceGroup, index) => {
                    if(resourceGroup.resources === undefined) {
                        return null;
                    }

                    return (
                        <ListGroup id={`resource-group-${index}-lesson-nav`} isDisclosureItem={true} key={index} title={resourceGroup.name} className={resourceGroup.styleClass} itemCount={resourceGroup.resources.length} startOpen={false} {...otherListGroupOptions}>
                            {resourceGroup.resources.map((resource, index) => {
                                const {name, iconClass, iconId} = resource;

                                const handleOnClick = () => {
                                    setNavVisible(false);
                                    if(resource.resourceType == 'QUESTION') {
                                        loadDialogTryIt(resource.questionId, resource.conceptId);
                                    } else if(resource.resourceType == 'TUTORIAL' && resource.tutorialSubType == 'EXAMPLE') {
                                        if(!handleScrollToExample(resource.exampleNum)) {
                                            if(resource.conceptId && resource.tutorialId && resource.featureFlag) {
                                                openExampleDialog(resource.conceptId, resource.tutorialId, resource.exampleNum, resource.name);
                                            } else if(resource.conceptId && resource.exampleNum) {
                                                openExampleDialogByExampleNum(resource.conceptId, resource.exampleNum);
                                            }
                                        }
                                    } else if(resource.resourceType == 'TUTORIAL' && resource.tutorialSubType == 'LESSON_CONTENT') {
                                        openReviewDialog(resource.tutorialId, resource.name);
                                    } else if(resource.resourceType == 'MEDIA' && (resource.mediaType == 'WIDGET' || resource.mediaType == 'VIDEO' || (resource.mediaType == 'DESMOS' && (resource.mediaSubType == 'DESMOS_GRAPHING' || resource.mediaSubType == 'DESMOS_GEOMETRY')))) {
                                        setDialogMediaObject({mediaId: resource.mediaId, mediaType: resource.mediaType, mediaSubType: resource.mediaSubType, mediaName: resource.name, conceptId: resource.conceptId});
                                    } else if(resource.resourceType == 'MEDIA' && resource.mediaType == 'DESMOS' && resource.mediaSubType == 'DESMOS_SCIENTIFIC') {
                                        loadScientificCalculator(resource.mediaId);
                                    } else if(resource.resourceType == 'MEDIA' && resource.mediaType == 'DESMOS' && resource.mediaSubType == 'DESMOS_MATRIX') {
                                        loadMaxtrixCalculator(resource.mediaId);
                                    } else if(resource.resourceType == 'MEDIA' && (resource.mediaType == 'WORKSHEET' || resource.mediaType == 'TEXTBOOK' || resource.mediaType == 'COURSE_DOCUMENTATION')) {
                                        window.open(resource.url, '_blank')
                                    } else if (resource.resourceType === 'MEDIA' && resource.mediaType === 'AUDIO') {
                                        if (audioRef.current.src === resource.url && !audioRef.current.paused) {
                                            audioRef.current.pause();
                                            audioRef.current.currentTime = 0;
                                        } else {
                                            audioRef.current.pause();
                                            audioRef.current.src = resource.url;
                                            audioRef.current.currentTime = 0;
                                            audioRef.current.play().catch(err => {
                                                console.error("Audio playback failed:", err);
                                            });
                                        }
                                    }
                                }
                                const Icons = {
                                    'example-icon': ExampleIcon,
                                    'tryit-icon': TryItIcon,
                                    'video-icon': VideoIcon,
                                    'video': VideoIcon,
                                    'audio-icon': AudioIcon,
                                    'widget-icon': WidgetIcon,
                                    'worksheet-icon': WorksheetIcon,
                                    'worksheet-solution-icon': WorksheetSolutionIcon,
                                    'file-download-word': DownloadFileIcon,
                                    'file-download-pdf': DownloadFileIcon,
                                    'file-download-powerpoint': DownloadFileIcon,
                                    'textbook-icon': TextbookIcon,
                                    'review-icon': ReviewIcon
                                }

                                return (
                                    <ListItem isDisclosureItem={true} key={index} icon={Icons[iconId]} iconType={ICON_TYPES.REACT_ICON} onClick={handleOnClick}>
                                        <span  dangerouslySetInnerHTML={{ __html: name}}></span>
                                    </ListItem>
                                )
                            })}
                        </ListGroup>);
                })
            }
        </ul>
    );
}

export default ResourceNavigation;